import React from 'react';
import './InviteFriendsModal.css';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import SignUpInviteForm from '../forms/SignUpInviteForm';
import { ReactComponent as InviteFriendIcon } from './invite-friend-icon.svg';

const InviteFriendsModal = ({ modal, toggle, inviteCode }) => {
    return (
        <Modal isOpen={modal} toggle={toggle} className="inviteFriendsModal">
            <ModalHeader className="align-items-center" toggle={toggle}>
                <InviteFriendIcon />
                <span className="ml-4 invite-friend__header-text">
                    <b className="mr-1">Invite friends</b>
                    to Sidekick Network
                </span>
            </ModalHeader>
            <ModalBody>
                <SignUpInviteForm toggle={toggle} inviteCode={inviteCode} />
            </ModalBody>
        </Modal>
    );
};

export default InviteFriendsModal;
